<template>
  <div>
    <el-table class="table_box pc_table_box" :data="pageData" style="width: 100%"
      v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.8)" :row-style="{ height: '59px' }"
    >
      <el-table-column prop="deal" :label="$t('contract2')" width="140px"></el-table-column>
      <el-table-column prop="time" :label="$t('time')" width="240px"></el-table-column>
      <el-table-column prop="open" :label="$t('direction')" width="180px">
        <template slot-scope="scope">
          <span v-if="scope.row.open===1" style="color: rgba(46, 189, 133, 1);">{{$t("long_position")}}</span>
          <span v-else  style="color: rgba(239, 69, 74, 1);">{{$t("short_position")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" :label="$t('type')" width="100px">
      </el-table-column>
      <el-table-column prop="targetPrice" :label="$t('trigger_price')" width="180px">
        <template slot-scope="scope">
          <span v-html="scope.row.targetPrice"></span>
        </template>
      </el-table-column>
      <el-table-column prop="entrustPrice" :label="$t('order_price2')" width="120px">
        <template slot-scope="scope">
          <span v-html="scope.row.entrustPrice"></span>
        </template>
      </el-table-column>


      <el-table-column prop="price" :label="$t('quantity')" width="120px"></el-table-column>
      <el-table-column prop="state" :label="$t('status')">
      </el-table-column>
    </el-table>
    <el-table v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)" class="table_box mobile_table_box" :data="pageData" style="width: 100%;padding: 0;margin-bottom: 20px"
              ref="table"
              @row-click="handleRowClick"
    >
      <el-table-column type="expand" :label="'#'">
        <template slot-scope="props"  >
          <div class="data_content" style="margin-top: 0">
            <div class="row">
              <div class="item">
                <div class="title">{{$t("type")}}</div>
                <div class="value">{{props.row.type}}</div>
              </div>
              <div class="item">
                <div class="title">{{$t('trigger_price')}}</div>
                <div class="value">
                  <span v-html="props.row.targetPrice"></span>
                </div>
              </div>
              <div class="item">
                <div class="title right">{{$t("quantity")}}</div>
                <div class="value right">{{props.row.price}}</div>
              </div>
            </div>
            <div class="row" style="margin-top: 15px">
              <div class="item">
                <div class="title">{{$t('trade_quantity')}}</div>
                <div class="value">{{props.row.price}}</div>
              </div>
              <div class="item">
                <div class="title right">{{$t('status')}}</div>
                <div class="value right">
                  <div class="value">{{props.row.state}}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deal" :label="$t('contract2')" width="80" ></el-table-column>
      <el-table-column prop="time" :label="$t('time')" >
        <template slot-scope="scope">
          <span v-html="scope.row.time"></span>
        </template>
      </el-table-column>
      <el-table-column prop="open" :label="$t('direction')"  width="60">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.open===1" style="color: rgba(46, 189, 133, 1);" >{{$t("long")}}</span>
            <span v-else style="color: rgba(239, 69, 74, 1);">{{$t("short")}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="entrustPrice" :label="$t('order_price2')" align="right">
        <template slot-scope="scope">
          <span v-html="scope.row.entrustPrice"></span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @prev-click="prevClick()"
                   @next-click="nextClick()"
                   :page-size="pageSize"
                   align="right"
                   :current-page.sync="currentPage"
                   layout="prev, pager, next"
                   style="margin-bottom: 300px"
                   :total="tableData1.length"/>

    <el-dialog :modal="false" style="margin-top: 24vh" :show-close="false" :visible.sync="dialogVisible" >
      <div class="text_box">
        {{$t('confirm_revoke_order')}}
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary" @click="ok1()">{{$t("confirm")}}</el-button>
        <el-button class="cancel_box" @click="dialogVisible = false">{{$t("cancel")}}</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import {
  createAndCall,
  createLeadingContractAndCall,
  createLeadingContractAndSend, createOrderBookAndCall, createPerpOptionAndCall, createTradeAndCall,
  getContractWithCache,
  getErc20Info, getSelectTokenInfo
} from "../utils/contract";
import {Contract, Method} from "../config/const";
import {isMobile, transBig2number, transTime2Date} from "../utils/functions";
import {getAccount} from "../utils/wallet";
import {registerMessage, removeMessage} from "../utils/message";
import {getHistoryData, getHistoryLimitOrder} from "../service/queryService";

export default {
  name: "activate8",
  props:{
    contractAddress:"",
    token:""
  },
  data(){
    return{
      tableData1: [],
      currentPage: 1,
      loading:false,
      dialogVisible:false,
      selectRow:undefined,
      showOrder:false,
      orderBook:"",
      pageData:[],
      pageSize:10

    }
  },
  created() {
    // this.init()
  },
  mounted() {
    registerMessage(this.updateMessage)
  },
  unmounted(){
    removeMessage(this.updateMessage)
  },
  watch:{
    currentPage(val){
      this.setPage(val)
    }
  },
  methods: {
    setPage(val){
      let start=(val - 1) * this.pageSize;
      this.pageData=this.tableData1.slice(start,start+this.pageSize)
    },
    async init(){
      console.log("init",8);
      this.loading=true;

      let tokenInfo=await getSelectTokenInfo(this.token);
      if(!tokenInfo){
        return;
      }
      this.orderBook=tokenInfo.orderBook;
      this.tableData1.length=0;
      let data = await this.getOrders()
      this.tableData1.push(...data);
      let info=await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress, [this.contractAddress]],3600000,createAndCall);
      let account=await getAccount();
      console.log("account is",info.traderAddress,account);
      if(info.traderAddress.toString().toLowerCase()===account.toString().toLowerCase()){
        this.showOrder=true;
      }

      this.loading=false;
      this.currentPage=1;
      this.setPage(1);
    },
    updateMessage(msg,data){
      // this.init()
    },
    prevClick(e){
      console.log(e)
      this.currentPage--
    },
    nextClick(){
      this.currentPage++
    },
    async getOrders(){
      if(!this.contractAddress){
        return [];
      }
      let limitOrders=await getHistoryLimitOrder(this.contractAddress,0)
      let selectToken=await getSelectTokenInfo(this.token);

      let orders=limitOrders.limitOrders;

      //获取止赢止损数据
      let orderIds=orders.map(e=>e.orderID)
      let conditions=await createTradeAndCall(selectToken.tradeAgent,Method.getTriggerConditions,orderIds)
      console.log("conditions is",conditions);

      console.log("order is",orders);
      let data=[];
      for(let i in orders){
        data.push({
          order:"0",
          deal:selectToken.symbol+"-"+orders[i].name,
          coin:selectToken.symbol,
          type: this.getOrderType(orders[i],conditions[i]),
          time: isMobile()?transTime2Date(parseInt(orders[i].startTime),true):transTime2Date(parseInt(orders[i].startTime)),
          price: transBig2number(orders[i].amount) ,
          price2: transBig2number(orders[i].targetPrice),
          pan:"",
          open:orders[i].direct,
          name:selectToken.symbol,
          timePrice: transBig2number(orders[i].tradingFee),
          state:this.getOrderStatus(orders[i].state),
          entrustPrice:this.getEntrustPrice(orders[i],conditions[i]),
          targetPrice:this.getTargetPrice(orders[i],conditions[i])
        })
      }
      return data;
    },
    //委托价格
    getEntrustPrice(order,target){
      if(order.orderType==21){
        return this.$t('market_order')
      }else if(order.orderType==11) {
        let html = "";
        let has = false;
        if (target.gainTriggerPrice.toString() != "0") {
          if(target.gainLimitPrice.toString()!="0"){
            html += transBig2number(target.gainLimitPrice)
          }else{
            html+="市价"
          }
          has = true;
        }
        if (target.lossTriggerPrice.toString() != "0") {
          if(target.lossLimitPrice.toString()!=0){
            html += (has ? "<br/>" : "") + transBig2number(target.lossLimitPrice)
          }else{
            html += (has ? "<br/>" : "") + "市价";
          }
        }
        return html;
      }else{
        return transBig2number(order.targetPrice)
      }

    },
    //触发价格
    getTargetPrice(order,target){
      if(order.orderType!=11){
        //return transBig2number(order.targetPrice)
        return "--";
      }
      let html="";
      let has=false;
      if(target.gainTriggerPrice.toString()!="0"){
        html+=transBig2number(target.gainTriggerPrice)
        has=true;
      }
      if(target.lossTriggerPrice.toString()!="0"){
        html+=(has?"<br/>":"")+transBig2number(target.lossTriggerPrice)
      }

      return html;

    },
    cancelShowDialog(row){
      this.selectRow=row;
      console.log("select row is",this.selectRow);
      this.dialogVisible=true;
    },
    handleRowClick(row){
      this.$refs.table.toggleRowExpansion(row)
    },
    ok1(){
      this.cancel(this.selectRow)
      this.dialogVisible=false;
    },
    getOrderStatus(type){
      //0-无效 1-挂单中 2-部分成交 3-全成 4-全撤 5-过期 6-异常
      let types=[this.$t('invalid'),this.$t("pending_order"),this.$t("partially_filled"),this.$t("fully_filled"),this.$t("fully_canceled"),this.$t("expired"),this.$t("abnormal")];
      return types[type];
    },
    getOrderType(order,target){

      if(order.orderType==11){
        if(target.gainTriggerPrice.toString()=="0" || target.lossTriggerPrice.toString()=="0"){
          return this.$t('one_side_order')
        }else{
          return this.$t('both_sides_order')
        }
      }else{
        if(order.offset==1){
          return this.$t('open_position');
        }else{
          return this.$t('close_position')
        }
      }
    }
  }
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
::v-deep .el-dialog__header{
  padding: 0!important;
}
::v-deep .el-dialog__body{
  padding: 18px 20px!important;

}
::v-deep .el-dialog__footer{
  padding: 0px 24px 22px!important;
}
.text_box{
  color: #ffffff;
  font-weight: 400;
  font-size: 15px;
}
::v-deep .el-dialog{
  width: 380px !important;
}
@media (max-width: 750px) {
  ::v-deep .el-dialog{
    width: 80% !important;
  }
  .data_content{
    margin-left: 15px;
    margin-right: 15px;
    .row{
      display: flex;
      //padding-top: 18px;
      //padding-bottom: 18px;
      //padding-left: 20px;
      //padding-right: 20px;
    }
    .item{
      flex: 1;
      .title{
        font-size: 13px;
        font-weight: 400;
        letter-spacing: -0.4px;
        line-height: 18.82px;
        color: rgba(128, 128, 128, 1);
      }
      .value{
        font-family: "Gilroy";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: -0.4px;
        line-height: 14.12px;
        color: rgba(255, 255, 255, 1);
        margin-top: 3px;
      }
      .right{
        text-align: right;
      }
      .operate_box{
        justify-content: end !important;
      }
    }
  }

}
::v-deep .el-table .cell{
  line-height: revert;
  padding-left: 0px;
}
::v-deep .el-table th.el-table__cell>.cell{
  padding-left: 0px;
}
</style>
<style>
.el-table, .el-table__expanded-cell{
background-color: rgba(24, 26, 32, 1);
}
</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
